"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useNextApiBaseUrl = void 0;
var router_1 = require("next/router");
/**
 * The prefix to every API url, e.g. /api
 * It will automatically include the router baseUrl
 */
function useNextApiBaseUrl() {
    var router = (0, router_1.useRouter)();
    var basePath = router && router.basePath ? router.basePath : '';
    return basePath;
}
exports.useNextApiBaseUrl = useNextApiBaseUrl;
